module.exports = __webpack_public_path__ + "img/avatar5.24371d69.png";